import * as Actions from '../../actions/invoice/type';

const initialState = {
  getInvoiceLoading: false,
  getInvoiceData: '',
  getInvoiceError: '',
};
export const invoiceReducer = (state = initialState, action) => {
  switch (action.type) {
    case Actions.GET_INVOICE_REQUEST:
      return {
        ...state,
        getInvoiceLoading: true,
      };
    case Actions.GET_INVOICE_SUCCESS:
      return {
        ...state,
        getInvoiceLoading: false,
        getInvoiceData: action?.payload?.data || '',
      };
    case Actions.GET_INVOICE_FAIL:
      return {
        ...state,
        getInvoiceLoading: false,
        getInvoiceError: action.payload,
      };

    case Actions.GET_INVOICES_REQUEST:
      return {
        ...state,
        getInvoicesLoading: true,
      };
    case Actions.GET_INVOICES_SUCCESS:
      return {
        ...state,
        getInvoicesLoading: false,
        invoices: action?.payload?.data || '',
      };
    case Actions.GET_INVOICES_FAIL:
      return {
        ...state,
        getInvoicesLoading: false,
        getInvoicesError: action.payload,
      };

    case Actions.CLEAR_GET_INVOICE_STATE:
      return {
        ...state,
        getInvoiceLoading: false,
        getInvoiceData: '',
        getInvoiceError: '',
      };

    default:
      return state;
  }
};
